import React from 'react';

import { Flex, SkeletonText, Spacer, Stack } from '@chakra-ui/react';

import borders from '@/styles/themes/brand/borders';

const ConsultantContractorSkeleton = () => {
  return (
    <Stack
      minW="100%"
      backgroundColor={'#fff'}
      borderRadius={borders.normal}
      px={'30px'}
      py={'35px'}
      mt={'30px'}
    >
      <SkeletonText noOfLines={1} w="200px" skeletonHeight="3" />

      <SkeletonText
        mt={'30px'}
        mb={'20px'}
        noOfLines={1}
        w="100%"
        maxW={'400px'}
        skeletonHeight="5"
      />

      <Flex mt={'10px'} flexDirection={{ base: 'column', md: 'row' }}>
        <SkeletonText noOfLines={1} w="200px" skeletonHeight="3" />
        <Spacer />
        <SkeletonText noOfLines={1} w="200px" skeletonHeight="3" />
      </Flex>

      <Flex mt={'10px'}>
        <SkeletonText
          noOfLines={1}
          w="100%"
          maxW={'500px'}
          skeletonHeight="3"
        />
        <Spacer />
        <SkeletonText noOfLines={1} w="200px" skeletonHeight="3" />
      </Flex>

      <Flex mt={'30px'} direction={'row'} gap={'20px'}>
        <SkeletonText
          mt={'30px'}
          noOfLines={1}
          w="100%"
          maxW={'400px'}
          skeletonHeight="5"
        />
        <SkeletonText
          mt={'30px'}
          noOfLines={1}
          w="100%"
          maxW={'400px'}
          skeletonHeight="5"
        />
      </Flex>
    </Stack>
  );
};
export default ConsultantContractorSkeleton;
